<template>
  <!-- 预约列表 -->
  <div class="page-reservation-list-person">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <div class="header mb-20">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/order/reservation/list' }">预约列表</el-breadcrumb-item>
          <el-breadcrumb-item>预约名单</el-breadcrumb-item>
        </el-breadcrumb>
        <a class="to-back" @click="goBack">
          <i class="el-icon-back"></i>&nbsp;&nbsp;返回
        </a>
      </div>
      <el-form class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="关键字 :" prop="key">
              <el-input v-model="form.key" placeholder="输入姓名/手机号/身份证号"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="预约时段 :" prop="appointTimes">
              <el-select v-model="form.appointTimes" placeholder="请选择">
                <el-option
                  v-for="item in timeList"
                  :key="item.id"
                  :label="item.openTimes ? item.startTime+'-'+item.endTime : item.startTime"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column label="预约入馆时间" min-width="20%">
            <template slot-scope="scope">
              <span>{{scope.row.appointEntryTime + ' '+scope.row.startTime+'~'+scope.row.endTime+''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="10%"></el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="12%"></el-table-column>
          <el-table-column prop="identificationNumber" label="证件号码" min-width="15%"></el-table-column>
          <el-table-column prop="createTime" label="提交时间" min-width="15%">
            <!-- <template slot-scope="scope">
              <span>{{scope.row.createTime | DateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
            </template>-->
          </el-table-column>
          <el-table-column prop="createUser" label="提交人" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="schemeNumber" label="状态" min-width="7%">
            <template slot-scope="scope">
              <span>{{scope.row.orderStatusName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="entryTime" label="入馆时间" min-width="10%"></el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination
            :current-page="listQuery.currentPage"
            :page-size="listQuery.size"
            :total="total"
            background
            layout="total, prev, pager, next, sizes, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>

    <dialogTicketSetting ref="dialogTicketSetting" @refresh="restList"></dialogTicketSetting>
  </div>
</template>

<script>
import dialogTicketSetting from './dialog-ticket-setting'
export default {
  components: {
    dialogTicketSetting
  },
  data() {
    return {
      form: {},
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      timeList: [],
      tableData: [],
      listLoading: true
    }
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      this.$http
        .get('/AppointOrderVisitor/getList', {
          id: this.$route.query.id,
          ...this.listQuery,
          ...this.form
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            if (
              type === 'dele' &&
              this.listQuery.currentPage > 1 &&
              !res.result.length
            ) {
              this.listQuery.currentPage -= 1
              this.initList()
              return
            }
            this.tableData = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 获取下拉状态选择值
    getDropdownValue() {
      this.$http.get('/AppointTicket/getSettingTimesList').then(res => {
        if (res.success) {
          var state = res.result
          let firstArr = [{ openTimes: null, startTime: '全部' }]
          this.timeList = firstArr.concat(state)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 点击返回
    goBack() {
      this.$router.push({ path: '/order/reservation/list' })
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    }
  },
  activated() {
    this.initList()
    this.getDropdownValue()
  }
}
</script>

<style lang="scss" scoped>
.page-reservation-list-person {
  padding: 30px;
  .header {
    position: relative;
    .el-breadcrumb {
      font-size: 18px;
      /deep/.el-breadcrumb__inner {
        font-weight: bold;
        color: rgba(87, 89, 98, 1);
      }
      /deep/.el-breadcrumb__inner.is-link,
      .el-breadcrumb__inner a {
        color: #9699a2;
      }
    }
    .to-back {
      position: absolute;
      top: 0;
      right: -240px;
      font-size: 14px;
      color: #9699a2;
    }
  }
  .com-list-header {
    .com-head-search-btns {
      top: 70px;
    }
  }
}
</style>